import { Box, Button, Divider, Drawer, IconButton } from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { loadWinnerListAction } from "redux/reducers/event/index";
import InfiniteScroll from "react-infinite-scroll-component";
import { rem, eventDateFormat, renderNoti } from "assets/js/common";
import React, { useEffect, useState, Suspense } from "react";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";

const useStyles = makeStyles((theme) => ({
  announcement: {
    "& .list-items": {
      padding: rem(30),
      "& .list-item": {
        "& img": {
          borderRadius: rem(10),
          width: "100%",
          height: rem(176),
          objectFit: "cover",
        },
        "& .tit": {
          paddingTop: rem(20),
          fontWeight: 700,
        },
        "& .sub-tit": {
          paddingTop: rem(4),
          fontSize: rem(14),
          color: theme.palette.text.disabled,
        },
        "& .date": {
          paddingTop: rem(4),
          fontSize: rem(14),
          color: theme.palette.text.disabled,
        },
        "& + .list-item": {
          paddingTop: rem(50),
        },
      },
    },
  },
}));

export default function EventWinnerList() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { schForm, winnerList, winner, loading } = useSelector(
    (state) => state.event
  );

  const cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [listData, setListData] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  // const [fetching, setFetching] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const [selectedSeq, setSelectedSeq] = useState("");

  const [rows, setRows] = useState({
    list: [],
  });

  const [initialized, setInitialized] = useState(true);

  const handleFav = () => {
    axios
      .post("/api/eh/event/like", {
        seq: winner.seq,
      })
      .then((res) => {
        dispatch(
          loadEventAction({
            seq: winner.seq,
            storeCode: storeCode || "ALL",
          })
        );
        console.log("winner", winner);
      });
  };

  const openPopup = (no) => {
    let info = winner.eventWinnerInfos.find((info) => info.mbrNo == no);
    if (info) {
      setDrawerOpen(true);
    } else {
      setAlertOpen(true);
    }
  };
  const checkWinnerInfos = () => {
    const no = cookies.get("no");
    openPopup(no);
  };

  const handleInfiniteScroll = () => {
    if (schForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }
    dispatch(
      loadWinnerListAction({
        pg: schForm.pg + 1,
        pgSz: 10,
        schStore: storeCode || "ALL",
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
      })
    );
  };

  useEffect(async () => {
    // setFetching(true);
    setRows({
      list: [],
    });
    dispatch(
      loadWinnerListAction({
        pg: 1,
        pgSz: 10,
        schStore: storeCode || "ALL",
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
      })
    );
  }, []);

  useEffect(() => {
    if (winnerList) {
      if (schForm.pg == 1) {
        setRows({
          ...winnerList,
        });
      } else {
        setRows({ ...winnerList, list: [...rows.list, ...winnerList.list] });
      }
    }
  }, [winnerList]);

  const handleRefresh = () => {
    return new Promise((resolve) => {
      dispatch(
        loadWinnerListAction({
          pg: 1,
          pgSz: 10,
          schStore: storeCode || "ALL",
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
        })
      );
      resolve(true);
    });
  };

  return (
    <>
      <Loading open={loading ? true : false} />
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={"flexItem " + classes.announcement}>
          <ul className="list-items">
            {/* {loading && (
          <li>
            {Array.from(Array(3)).map((_, index) => (
              <>
                <div
                  style={{
                    borderRadius: rem(10),
                    width: "100%",
                    height: rem(176),
                    backgroundColor: "#CCCCCC",
                  }}
                />
                <Box pt={4} pb={10}>
                  <Skeleton height={30} width={200} />
                  <Skeleton height={30} />
                  <Skeleton height={30} width={100} />
                </Box>
              </>
            ))}
          </li>
        )} */}
            {rows.list.length == 0 ? (
              <div className="nodata mt15">
                <Box className="illust">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                  />
                </Box>
                <p className="color-info">당첨자 발표 내역이 없습니다.</p>
              </div>
            ) : (
              <InfiniteScroll
                dataLength={rows.list.length}
                next={handleInfiniteScroll}
                hasMore={setInitialized}
                inverse={false}
              >
                {rows.list.map((item, i) => (
                  <li
                    key={i}
                    className="list-item"
                    onClick={() => {
                      setSelectedSeq(item.seq);
                      history.push(`/event/winner/${item.seq}`);
                    }}
                  >
                    <span style={{ display: "block", height: "176px" }}>
                      <LazyCDNImage
                        cdnUrl={item.repImgUrl}
                        style={{ height: "176px", borderRadius: "10px" }}
                      />
                    </span>
                    <div className="tit">{item.ttl}</div>
                    <div className="sub-tit">{item.desc}</div>
                    <div className="date">
                      {eventDateFormat(item.expsStrtYmd, item.expsEndYmd)}
                    </div>
                  </li>
                ))}
              </InfiniteScroll>
            )}
          </ul>
          <Drawer
            anchor="bottom"
            open={detailOpen}
            onClose={() => {
              setDetailOpen(false);
            }}
            className="drawer-common-bottom size-high event-drawer"
          >
            <div className="drawer-head">
              <h3>당첨자 발표</h3>
              <IconButton
                aria-label="close"
                className="btn-close"
                onClick={() => {
                  setDetailOpen(false);
                }}
              >
                <span className="hidden">닫기</span>
              </IconButton>
            </div>

            <div className="drawer-body">
              {/* <EventDetailDefault selectedSeq={selectedSeq} mode={"winner"} /> */}

              <Box className="box-type-7">
                <div className="tit">{winner.ttl}</div>
                <div className="sub-tit">{winner.desc}</div>

                <div className="board-info">
                  <span>
                    {eventDateFormat(winner.expsStrtYmd, winner.expsEndYmd)}
                  </span>
                  <span>이벤트</span>
                </div>
              </Box>

              <Box pb={2}>
                <span style={{ display: "block", height: "300px" }}>
                  <LazyCDNImage
                    cdnUrl={winner.progImgUrl}
                    style={{ height: "300px", borderRadius: "0" }}
                  />
                </span>
              </Box>

              {winner.noti && (
                <Box className="box-type-1">
                  <Box className="notice">
                    <p className="title">
                      <i className="ico-noti" />
                      유의사항
                    </p>
                    <ul className="list list-dot color-info font-14">
                      {renderNoti(winner.noti).map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              )}
            </div>

            <Divider />

            <Box className="box-type-1">
              <div className="fav">
                {winner.favYn == "Y" ? (
                  <>
                    <Button onClick={handleFav}>
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/favorite.svg`}
                      />
                    </Button>
                    <span style={{ color: "#F1270B" }}>{winner.favCnt}</span>
                  </>
                ) : (
                  <>
                    <Button onClick={handleFav}>
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/favorite-off.svg`}
                      />
                    </Button>
                    <span style={{ color: "#CCCCCC" }}>{winner.favCnt}</span>
                  </>
                )}
              </div>
            </Box>

            <div className="drawer-foot">
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  checkWinnerInfos();
                }}
              >
                당첨결과 확인하기
              </Button>
            </div>
          </Drawer>
        </div>
      </PullToRefresh>
    </>
  );
}
